(function initializeCustomifyTranslations(root) {
  'use strict';

  var DEFAULT_LOCALE = 'en';
  var context = root.CustomifyI18n || {};
  var missingKeys = new Set();
  var messages = Object.freeze({
    en: Object.freeze({
      'phone.brand.label': 'Choose phone brand',
      'phone.brand.placeholder': 'Choose brand',
      'phone.error.load_models': 'Could not load the model list. Refresh the page.',
      'phone.error.no_brands': 'No brand list available.',
      'phone.model.label': 'Choose phone model',
      'phone.model.placeholder': 'Choose model',
      'phone.model.select_brand_first': 'Choose a brand first',
      'customizer.print_type': 'Print type:',
      'customizer.product_type.poster': 'Poster (add a frame)',
      'customizer.product_type.canvas': 'Canvas print',
      'customizer.product_type.digital': 'Digital product',
      'customizer.frame.label': 'Frame:',
      'customizer.frame.none': 'No frame',
      'customizer.frame.black': 'Black',
      'customizer.frame.white': 'White',
      'customizer.frame.wood': 'Wood',
      'customizer.frame.classic_canvas': 'Classic frame – stretcher frame',
      'customizer.frame.black_canvas': 'Premium frame – American Box Black',
      'customizer.frame.wood_canvas': 'Premium frame – American Box Natural Wood',
      'customizer.size.imperial': 'Size (inches):',
      'customizer.size.metric': 'Size (cm):',
      'customizer.upload.title': 'Upload a photo and see the result instantly',
      'customizer.upload.add_photo': 'Add photo',
      'customizer.multi_upload.title': 'Upload photos of people (max 4)',
      'customizer.multi_upload.person_1': 'Person 1 *',
      'customizer.multi_upload.person_2': 'Person 2',
      'customizer.multi_upload.person_3': 'Person 3',
      'customizer.multi_upload.person_4': 'Person 4',
      'customizer.multi_upload.uploaded': 'Uploaded:',
      'customizer.multi_upload.photos': 'photos',
      'customizer.preview.your_photo': 'Your photo:',
      'customizer.style.choose': 'Choose style',
      'customizer.style.watercolor': 'Watercolor',
      'customizer.action.see_preview': 'See preview',
      'customizer.action.upload_another': 'Upload another photo',
      'customizer.action.add_to_cart': 'Add to cart',
      'customizer.action.try_again': 'Try again',
      'customizer.cart.price': 'Price:',
      'customizer.cart.confirm_design': 'Made just for you. Please confirm your design and options before ordering.',
      'customizer.loading.wait': 'Generation can take up to 2 minutes - please wait',
      'customizer.loading.uploading_photo': 'Uploading photo...',
      'customizer.loading.preparing_ai': 'Preparing AI...',
      'customizer.loading.generating_image': 'Generating image...',
      'customizer.loading.finalizing': 'Finalizing...',
      'customizer.loading.almost_ready': 'Almost ready...',
      'customizer.result.your_image': 'Your image:',
      'customizer.result.watermark_notice': 'Watermarks will not appear on the final product',
      'customizer.success.project_ready': 'Project ready! Choose print options and add to cart.',
      'customizer.success.saved_logged_in': 'Your image is ready! Choose your print options and click “Add to cart” to order. A copy is saved in',
      'customizer.success.saved_guest': 'Your image is ready! Choose your print options and click “Add to cart” to order. A copy is saved in My images below.',
      'customizer.success.my_images': 'My images',
      'customizer.success.correction_note': 'Need a small correction, such as text or spelling? Add a note with your order so our designer can make the adjustment.',
      'customizer.personalization.title': 'Personalization',
      'customizer.gallery.title': 'Your images - choose the best one',
      'customizer.cart.adding': 'Adding to cart...',
      'customizer.cart.creating_product': 'Creating product...',
      'customizer.cart.uploading_image': 'Uploading image...',
      'customizer.accordion.about': 'About the product',
      'customizer.accordion.shipping': 'Shipping and delivery',
      'customizer.accordion.sizes': 'Available sizes',
      'customizer.accordion.how_it_works': 'How it works?',
      'customizer.details.canvas': 'Canvas print',
      'customizer.details.classic_frame': 'Classic frame',
      'customizer.details.classic_frame_description': 'Printed on thick, premium canvas with a natural texture. Stretched over a wooden stretcher frame and ready to hang on the wall.',
      'customizer.details.premium_frame': 'Premium frame – American BOX',
      'customizer.details.premium_frame_description': 'A canvas in a wooden floating frame, with a visible shadow gap between the artwork and the outer frame. A premium finish available in black or natural wood.',
      'customizer.details.poster': 'Poster',
      'customizer.details.unframed_poster': 'Unframed poster',
      'customizer.details.unframed_poster_description': 'Printed on photographic paper and shipped rolled in a sturdy tube — ideal if you want to frame it yourself.',
      'customizer.details.framed_poster': 'Framed poster',
      'customizer.details.framed_poster_description': 'Printed on photographic paper and mounted in a wooden frame behind lightweight, shatter-resistant acrylic glazing. Choose black, white, or natural wood. Ready to hang on a wall or display on a desk.',
      'customizer.details.digital': 'Digital product',
      'customizer.details.digital_description': 'Digital product – watermark-free image sent by email after payment. No physical shipping.',
      'customizer.details.packages': 'Packages: available package prices are shown on the product page and at checkout.',
      'customizer.details.digital_how': 'How it works: Buy a package, for example 3 images. The first image is emailed immediately; the remaining 2 are saved as credits on your account. Come back, generate a new portrait, and click “Download for 1 credit”. Credits do not expire.',
      'customizer.shipping.production': '⚡ Production: usually 2–5 business days after artwork approval',
      'customizer.shipping.packaging': '📦 Secure packaging: Reinforced box and bubble wrap for safe delivery',
      'customizer.shipping.options': '🇺🇸 Shipping: available shipping options at checkout',
      'customizer.shipping.tracking': '📍 Tracking: Tracking number is sent by email so you can follow your package',
      'customizer.shipping.cost': '🚚 Shipping cost: calculated at checkout',
      'customizer.shipping.delivery_time': '⏰ Delivery time: estimated at checkout depending on the selected option',
      'customizer.sizes.prints': '🖼️ Poster / Canvas print',
      'customizer.sizes.available': '📏 Available sizes',
      'customizer.sizes.description_imperial': 'Available sizes are shown in the customizer above and vary by print format. Measurements are displayed in inches.',
      'customizer.sizes.description_metric': 'Available sizes are shown in the customizer above and vary by print format. Measurements are displayed in centimeters.',
      'footer.policy_navigation': 'Policy navigation:',
      'footer.policy.privacy': 'Privacy Policy',
      'footer.policy.refund': 'Refund Policy',
      'footer.policy.contact': 'Contact Information',
      'footer.policy.terms': 'Terms of Service',
      'footer.policy.shipping': 'Shipping Policy',
      'theme.header.my_account': 'My account',
      'theme.header.my_images': 'My images',
      'theme.header.log_out': 'Log out',
      'theme.header.log_in': 'Log in',
      'theme.header.register': 'Register',
      'theme.header.search': 'Search',
      'theme.header.cart': 'Cart',
      'theme.breadcrumb.label': 'Breadcrumb',
      'theme.breadcrumb.home': 'Home',
      'theme.breadcrumb.products': 'Products',
      'theme.hero.eyebrow': 'Personalized artwork from your photo',
      'theme.hero.title': 'Turn a favorite photo into a gift they will never forget',
      'theme.hero.description': 'Upload a photo, generate your preview, and order only after you are happy with the result.',
      'theme.hero.create': 'Create your artwork',
      'theme.hero.how': 'See how it works',
      'theme.hero.benefits': 'Store benefits',
      'theme.hero.preview': 'Preview before checkout',
      'theme.hero.made': 'Made to order',
      'theme.hero.delivery': 'Tracked delivery options',
      'theme.recommendations.title': 'You may also like',
      'theme.recommendations.view_all': 'View all products',
      'theme.reviews.title': 'Customer reviews',
      'theme.reviews.view_all': 'View all reviews',
      'theme.reviews.rating': '4.9/5 (143 reviews)',
      'theme.reviews.1.date': 'Jun 18, 2026',
      'theme.reviews.1.text': '“I uploaded a regular phone photo of my dad and the caricature preview actually looked like him. The canvas arrived sharp, not blurry, and the colors were close to what I approved on screen.”',
      'theme.reviews.1.style': 'Verified purchase · Canvas print',
      'theme.reviews.2.date': 'Jun 11, 2026',
      'theme.reviews.2.text': '“Bought this as a birthday gift for my wife. The best part was seeing the preview before checkout. It felt personal, not like a generic poster with our photo pasted on it.”',
      'theme.reviews.2.style': 'Verified purchase · Framed poster',
      'theme.reviews.3.date': 'May 29, 2026',
      'theme.reviews.3.text': '“I was nervous because the photo I used was not perfect, but the preview made it easy to decide. The framed print looks clean and the face details came through better than expected.”',
      'theme.reviews.3.style': 'Verified purchase · Wooden framed poster',
      'theme.reviews.4.date': 'May 21, 2026',
      'theme.reviews.4.text': '“Ordered one for my brother and he laughed before he even unwrapped it fully. The caricature was funny without being mean, which is exactly what I wanted.”',
      'theme.reviews.4.style': 'Verified purchase · Caricature portrait',
      'theme.reviews.5.date': 'May 9, 2026',
      'theme.reviews.5.text': '“The print was a gift for my parents. I liked that I could choose the size and frame after seeing the AI result. It looks more premium than I expected.”',
      'theme.reviews.5.style': 'Verified purchase · Framed canvas',
      'theme.reviews.6.date': 'Apr 27, 2026',
      'theme.reviews.6.text': '“I used a picture of our dog and the result still kept his expression. The poster came packed well and the image looked crisp, not like a cheap enlargement.”',
      'theme.reviews.6.style': 'Verified purchase · Pet portrait poster',
      'theme.reviews.7.date': 'Apr 14, 2026',
      'theme.reviews.7.text': '“The preview matched the final print closely. I appreciated that the artwork was created from my uploaded photo, so it felt like a one-of-one gift.”',
      'theme.reviews.7.style': 'Verified purchase · Custom AI portrait',
      'theme.cart.title': 'Cart',
      'theme.cart.view_all': 'View all',
      'theme.cart.property.size': 'Size:',
      'theme.cart.property.print_type': 'Print type:',
      'theme.cart.property.frame': 'Frame:',
      'theme.cart.checkout': 'Check out',
      'theme.cart.payment_alt': 'Accepted payment methods: Mastercard, Maestro, Visa, Visa Electron and Apple Pay',
      'theme.cart.payment_title': 'Cards, Apple Pay & Google Pay',
      'theme.cart.payment_text': 'Secure card and wallet payments',
      'theme.cart.made_title': 'Made to order',
      'theme.cart.made_text': 'Usually produced in 2–5 business days',
      'theme.cart.delivery_title': 'Tracked delivery',
      'theme.cart.delivery_text': 'Shipping options shown at checkout',
      'theme.cart.printing_title': 'USA-based printing',
      'theme.cart.printing_text': 'Printed for customers across the United States',
      'customizer.howto.upload_title': 'Upload your photo',
      'customizer.howto.upload_description': 'JPG, PNG, or GIF up to 10MB. High resolution works best.',
      'customizer.howto.upload_note': 'Do not worry about quality – we check every photo before printing and improve it so it looks right.',
      'customizer.howto.style_title': 'Choose an artistic style',
      'customizer.howto.style_description': 'Available styles are shown in the section above.',
      'customizer.howto.size_title': 'Choose your print size',
      'customizer.howto.size_description': 'Choose the best size for your space.',
      'customizer.howto.ai_title': 'AI will transform your photo',
      'customizer.howto.ai_description': 'Advanced AI technology creates your preview in 30–60 seconds.',
      'customizer.howto.ship_title': 'We print and ship',
      'customizer.howto.ship_description': 'Every image is checked before printing. High-quality print, packed securely.',
      "customizer.upload.photo": "Photo {number}",
      "customizer.upload.file_type": "We cannot open this file.",
      "customizer.upload.file_size": "This photo file is too large.",
      "customizer.upload.file_empty": "We cannot open this photo.",
      "customizer.upload.file_resolution": "This photo is too small. Please choose a larger photo.",
      "customizer.upload.low_resolution_warning": "You can use this photo, but details may be less accurate. A larger, clearer photo will give better results.",
      "customizer.upload.file_decode": "We cannot open this photo.",
      "customizer.upload.file_read": "We cannot open this photo.",
      "customizer.upload.file_upload": "We could not send this photo. Please check your connection and try again.",
      "customizer.upload.file_timeout": "This photo could not be loaded. Please try again.",
      "customizer.upload.browser_unsupported": "Your browser cannot read photo files. Update it or try another browser.",
      "customizer.upload.crop_export": "We could not crop this photo.",
      "customizer.upload.crop_unavailable": "The photo editor could not be loaded. Refresh the page and try again.",
      "customizer.upload.choose_another": "Choose another photo.",
      "customizer.upload.previous_kept": "Your previous photo is still selected.",
      "customizer.upload.still_loading": "Your photo is still being checked. Wait for the preview before continuing.",
      "customizer.upload.checking": "Checking photo…",
      "customizer.upload.compression": "The photo could not be compressed.",
      "customizer.upload.missing_photo": "Please add a photo before continuing.",
      "customizer.upload.crop_required": "Please confirm the photo crop before continuing.",
      'customizer.error.image_file': 'Choose an image file (JPG, PNG)',
      'customizer.error.file_too_large': 'File is too large (max 10MB)',
      'customizer.error.upload_photo_style': 'Upload a photo and choose a style',
      'customizer.error.size_required': 'You have not selected a size',
      'customizer.error.product_type_unavailable': 'This product type is not available. Choose canvas, poster, or digital.',
      'customizer.error.generate_preview_first': 'First, upload a photo to generate your preview',
      'customizer.error.choose_style': 'Choose a style',
      'customizer.error.price_calculation': 'Price calculation failed. Try again.',
      'customizer.error.ai_failed': 'AI transformation failed: {reason}',
      'customizer.error.unknown': 'Unknown error',
      'customizer.error.network_retry': 'Network error – retrying {attempt}/3...',
      'customizer.error.server_connection': 'Server connection failed',
      'customizer.error.transform_timeout': 'The request timed out (5 minutes). Try again.',
      'customizer.error.network_check': 'Network error. Check your internet connection and try again.',
      'customizer.error.network_short': 'Network error. Try again shortly.',
      'customizer.error.processing': 'Processing failed. Try again.',
      'customizer.error.add_to_cart': 'Could not add to cart. Try again.',
      'customizer.error.product_creation': 'Product creation failed: {reason}',
      'customizer.field.name.label': 'Name or dedication - this text will appear at the bottom of the image',
      'customizer.field.name.placeholder': 'e.g. Anna',
      'customizer.field.names.label': 'Names or dedication - this text will appear on the image',
      'customizer.field.names.placeholder': 'e.g. Anna & Mark',
      'customizer.field.years.label': 'Anniversary / number of years - this number will appear on the image',
      'customizer.field.years.placeholder': 'e.g. 10, 25, 50',
      'customizer.field.personalization.label': 'Describe the person, job, hobby or theme - this will guide the image style',
      'customizer.field.personalization.placeholder': 'e.g. nurse, travel | teacher, sport',
      'customizer.field.signature.label': 'Name and surname (signature at the bottom)',
      'customizer.field.signature.placeholder': 'e.g. MARK SMITH',
      'customizer.field.watercolor_text.label': 'Add a signature or dedication - it will appear at the bottom of the image',
      'customizer.field.watercolor_text.placeholder': 'e.g. Power Couple',
      'customizer.field.story_scene.label': 'Pose or scene (optional)',
      'customizer.field.story_dedication.label': 'Add a short dedication (optional)',
      'customizer.field.story_dedication.placeholder': 'e.g. Forever Together',
      'customizer.story.saloon.1': 'Standing',
      'customizer.story.saloon.2': 'Seated at a table',
      'customizer.story.saloon.3': 'On horseback',
      'customizer.story.royal.1': 'One seated, one standing',
      'customizer.story.royal.2': 'Both standing',
      'customizer.story.royal.3': 'Both seated',
      'customizer.story.swing.1': 'On the swing',
      'customizer.story.swing.2': 'On a bench',
      'customizer.story.swing.3': 'Standing together',
      'customizer.story.highland.1': 'On a Highland ridge',
      'customizer.story.romantic.1': "As shown in the product image",
      'customizer.story.romantic.2': "Standing in the garden",
      'customizer.story.romantic.3': "By a stone balcony",
      'customizer.story.legacy.1': "As shown in the product image",
      'customizer.story.legacy.2': "Standing together",
      'customizer.story.legacy.3': "Seated together",
      'customizer.story.fairytale.1': "As shown in the product image",
      'customizer.story.fairytale.2': "Standing in the garden",
      'customizer.story.fairytale.3': "Holding a small bouquet",
      'customizer.story.dynasty.1': "In a stately manor",
      'customizer.story.dynasty.2': "In a grand library",
      'customizer.story.dynasty.3': "On a garden terrace",
      'customizer.story.floral.1': "In a flower conservatory",
      'customizer.story.floral.2': "By a stone balustrade",
      'customizer.story.floral.3': "On a rose garden path",
      'customizer.story.ballroom.1': "Dancing in the ballroom",
      'customizer.story.ballroom.2': "Standing beneath chandeliers",
      'customizer.story.ballroom.3': "By tall ballroom windows",
      'customizer.story.regal.1': "In an old great hall",
      'customizer.story.regal.2': "In a private library",
      'customizer.story.regal.3': "By a tall stone window",
      'customizer.story.tree.1': "Beneath the ancient tree",
      'customizer.story.tree.2': "In a wildflower meadow",
      'customizer.story.tree.3': "Overlooking rolling hills",
      'customizer.story.deco.1': 'In an Art Deco lobby',
      'customizer.story.deco.2': 'By a vintage car',
      'customizer.story.deco.3': 'At a grand staircase',
      'customizer.story.sapphire.1': 'In a palace gallery',
      'customizer.story.sapphire.2': 'By tall windows',
      'customizer.story.sapphire.3': 'On a garden terrace',
      'customizer.story.aviator.1': 'Beside a parked plane',
      'customizer.story.aviator.2': 'In an airfield hangar',
      'customizer.story.aviator.3': 'On a grassy runway',
      'customizer.story.power.1': 'In a city penthouse',
      'customizer.story.power.2': 'By skyline windows',
      'customizer.story.power.3': 'On a rooftop terrace',
      'customizer.story.highland.2': 'Beside a stone castle',
      'customizer.story.highland.3': 'By a misty loch',
      'customizer.story.viking.1': 'By a Nordic fjord',
      'customizer.story.mafia_portrait.1': 'Seated in a leather chair',
      'customizer.story.mafia_portrait.2': 'Standing in a library',
      'customizer.story.mafia_portrait.3': 'By a vintage car',
      'customizer.story.royal_portrait.1': 'In a palace gallery',
      'customizer.story.royal_portrait.2': 'Seated on a throne',
      'customizer.story.royal_portrait.3': 'By tall windows',
      'customizer.story.knight_portrait.1': 'By a castle archway',
      'customizer.story.knight_portrait.2': 'In a great hall',
      'customizer.story.knight_portrait.3': 'In a castle courtyard',
      'customizer.story.viking.2': 'Beside a longship',
      'customizer.story.viking.3': 'In a great hall',
      'customizer.story.pirate.1': 'Standing together on deck',
      'customizer.story.pirate.2': 'At the ship’s wheel',
      'customizer.story.pirate.3': 'Seated on a chest',
      'customizer.story.cowboy.1': 'On horseback',
      'customizer.story.cowboy.2': 'Standing in town',
      'customizer.story.cowboy.3': 'Standing against a canyon',
      'customizer.field.headline_1.label': 'Headline 1 (optional)',
      'customizer.field.headline_1.placeholder': 'Default: ARCHITECT OF MY OWN EMPIRE',
      'customizer.field.headline_2.label': 'Headline 2 (optional)',
      'customizer.field.headline_2.placeholder': 'Default: SUCCESS IS STRATEGY, NOT LUCK',
      'customizer.field.scene_type.label': 'Scene type',
      'customizer.field.scene_type.placeholder': 'e.g. anniversary',
      'customizer.field.character_description.label': 'Describe the character or mood',
      'customizer.field.character_description.placeholder': 'e.g. elegant, romantic, celebratory',
      'customizer.field.couple_pose.label': 'Couple pose',
      'customizer.field.groom_outfit.label': "Groom's outfit",
      'customizer.field.groom_outfit.placeholder': 'e.g. green suit, black tuxedo, navy blazer',
      'customizer.field.bride_outfit.label': "Bride's outfit",
      'customizer.field.bride_outfit.placeholder': 'e.g. white dress with a veil, strapless wedding dress',
      'customizer.field.wedding_background.label': 'Background / location',
      'customizer.field.wedding_background.placeholder': 'e.g. church, outdoor ceremony, wedding venue, beach at sunset',
      'customizer.field.scene_description.label': 'Describe the scene or mood',
      'customizer.field.scene_description.placeholder': 'e.g. family dinner, business meeting, picnic in the park',
      'customizer.field.dedication.label': 'Add text or dedication',
      'customizer.field.dedication.placeholder': 'e.g. Dear Mom, Happy Holidays!',
      'customizer.field.banner_text.label': 'Add text to appear on the ribbon in the image',
      'customizer.field.banner_text.placeholder': 'e.g. Anna and Mark, always together',
      'customizer.field.gta_text.label': 'You can add text; it will appear at the bottom of the image',
      'customizer.field.gta_text.placeholder': 'e.g. Power Couple',
      'customizer.field.gta_look.label': 'Outfit / look',
      'customizer.field.gta_scene.label': 'Scene / city',
      'customizer.field.gta_vehicle.label': 'Vehicle',
      'customizer.field.gta_mood.label': 'Mood',
      'customizer.field.gta_props.label': 'What else should be in the image? (optional)',
      'customizer.field.gta_props.placeholder': 'e.g. husky, guitar, my black BMW E46',
      'customizer.gta.look.1': 'Vice City – Hawaiian shirt, bikini/crop top',
      'customizer.gta.look.2': 'Gangster – gold chains, tank top, bandana',
      'customizer.gta.look.3': 'Street – leather jacket, hoodie, sneakers',
      'customizer.gta.look.4': 'Boss – suit, cocktail dress',
      'customizer.gta.look.5': 'As in the photo',
      'customizer.gta.scene.1': 'Vice City – beach, palms, neon',
      'customizer.gta.scene.2': 'Los Santos – downtown, skyscrapers',
      'customizer.gta.scene.3': 'City at night – rain, neon',
      'customizer.gta.scene.4': 'Hills – pool villa, city view',
      'customizer.gta.scene.5': 'Garage / workshop',
      'customizer.gta.vehicle.1': 'Supercar',
      'customizer.gta.vehicle.2': 'Motorcycle',
      'customizer.gta.vehicle.3': 'Retro convertible',
      'customizer.gta.vehicle.4': 'Helicopter in the background',
      'customizer.gta.vehicle.5': 'No vehicle',
      'customizer.gta.mood.1': 'Action – money, explosions, police in the background',
      'customizer.gta.mood.2': 'Relaxed – vacation, beach, drinks',
      'customizer.gta.mood.3': 'Elegant – suits, casino, city at night'
    }),
    de: Object.freeze({
      'phone.brand.label': 'Handymarke auswählen',
      'phone.brand.placeholder': 'Marke auswählen',
      'phone.error.load_models': 'Die Modellliste konnte nicht geladen werden. Bitte lade die Seite neu.',
      'phone.error.no_brands': 'Keine Markenliste verfügbar.',
      'phone.model.label': 'Handymodell auswählen',
      'phone.model.placeholder': 'Modell auswählen',
      'phone.model.select_brand_first': 'Wähle zuerst eine Marke aus',
      'customizer.print_type': 'Druckart:',
      'customizer.product_type.poster': 'Poster (mit Rahmen)',
      'customizer.product_type.canvas': 'Leinwanddruck',
      'customizer.product_type.digital': 'Digitales Produkt',
      'customizer.frame.label': 'Rahmen:',
      'customizer.frame.none': 'Ohne Rahmen',
      'customizer.frame.black': 'Schwarz',
      'customizer.frame.white': 'Weiß',
      'customizer.frame.wood': 'Holz',
      'customizer.frame.classic_canvas': 'Klassischer Keilrahmen',
      'customizer.frame.black_canvas': 'Premiumrahmen – American Box Schwarz',
      'customizer.frame.wood_canvas': 'Premiumrahmen – American Box Naturholz',
      'customizer.size.imperial': 'Größe (Zoll):',
      'customizer.size.metric': 'Größe (cm):',
      'customizer.upload.title': 'Lade ein Foto hoch und sieh dein Ergebnis sofort',
      'customizer.upload.add_photo': 'Foto hochladen',
      'customizer.multi_upload.title': 'Fotos der Personen hochladen (max. 4)',
      'customizer.multi_upload.person_1': 'Person 1 *',
      'customizer.multi_upload.person_2': 'Person 2',
      'customizer.multi_upload.person_3': 'Person 3',
      'customizer.multi_upload.person_4': 'Person 4',
      'customizer.multi_upload.uploaded': 'Hochgeladen:',
      'customizer.multi_upload.photos': 'Fotos',
      'customizer.preview.your_photo': 'Dein Foto:',
      'customizer.style.choose': 'Stil auswählen',
      'customizer.style.watercolor': 'Aquarell',
      'customizer.action.see_preview': 'Vorschau anzeigen',
      'customizer.action.upload_another': 'Anderes Foto hochladen',
      'customizer.action.add_to_cart': 'In den Warenkorb',
      'customizer.action.try_again': 'Erneut versuchen',
      'customizer.cart.price': 'Preis:',
      'customizer.cart.confirm_design': 'Nur für dich angefertigt. Bitte prüfe vor der Bestellung dein Design und deine gewählten Optionen.',
      'customizer.loading.wait': 'Die Erstellung kann bis zu 2 Minuten dauern – bitte warte',
      'customizer.loading.uploading_photo': 'Foto wird hochgeladen...',
      'customizer.loading.preparing_ai': 'KI wird vorbereitet...',
      'customizer.loading.generating_image': 'Bild wird erstellt...',
      'customizer.loading.finalizing': 'Fast fertig...',
      'customizer.loading.almost_ready': 'Gleich bereit...',
      'customizer.result.your_image': 'Dein Bild:',
      'customizer.result.watermark_notice': 'Wasserzeichen sind auf dem fertigen Produkt nicht sichtbar',
      'customizer.success.project_ready': 'Dein Entwurf ist fertig. Wähle die Druckoptionen und lege ihn in den Warenkorb.',
      'customizer.success.saved_logged_in': 'Bild gespeichert. Du findest es unter',
      'customizer.success.saved_guest': 'Bild gespeichert. Du kannst es später unten unter „Meine Bilder“ ansehen.',
      'customizer.success.my_images': 'Meine Bilder',
      'customizer.success.correction_note': 'Falls im Bild etwas nicht stimmt, zum Beispiel Text oder Schreibweise, kann unser Designer es manuell korrigieren. Füge bei der Bestellung eine Notiz hinzu.',
      'customizer.personalization.title': 'Personalisierung',
      'customizer.gallery.title': 'Deine Bilder – wähle das beste aus',
      'customizer.cart.adding': 'Wird zum Warenkorb hinzugefügt...',
      'customizer.cart.creating_product': 'Produkt wird erstellt...',
      'customizer.cart.uploading_image': 'Bild wird hochgeladen...',
      'customizer.accordion.about': 'Über das Produkt',
      'customizer.accordion.shipping': 'Versand und Lieferung',
      'customizer.accordion.sizes': 'Verfügbare Größen',
      'customizer.accordion.how_it_works': 'So funktioniert es',
      'customizer.details.canvas': 'Leinwanddruck',
      'customizer.details.classic_frame': 'Klassischer Keilrahmen',
      'customizer.details.classic_frame_description': 'Gedruckt auf hochwertiger Leinwand mit natürlicher Struktur. Auf einen Holzkeilrahmen gespannt und fertig zum Aufhängen.',
      'customizer.details.premium_frame': 'Premiumrahmen – American BOX',
      'customizer.details.premium_frame_description': 'Leinwand in einem schwebenden Holzrahmen mit sichtbarer Schattenfuge zwischen Bild und Außenrahmen. Erhältlich in Schwarz oder Naturholz.',
      'customizer.details.poster': 'Poster',
      'customizer.details.unframed_poster': 'Poster ohne Rahmen',
      'customizer.details.unframed_poster_description': 'Auf Fotopapier gedruckt und sicher gerollt in einer stabilen Röhre versendet – ideal, wenn du es selbst rahmen möchtest.',
      'customizer.details.framed_poster': 'Poster mit Rahmen',
      'customizer.details.framed_poster_description': 'Auf Fotopapier gedruckt und in einem Holzrahmen hinter leichtem, bruchsicherem Acrylglas montiert. Wähle Schwarz, Weiß oder Naturholz. Fertig zum Aufhängen oder Aufstellen.',
      'customizer.details.digital': 'Digitales Produkt',
      'customizer.details.digital_description': 'Digitales Produkt – Bild ohne Wasserzeichen, das nach der Zahlung per E-Mail versendet wird. Kein physischer Versand.',
      'customizer.details.packages': 'Pakete: Die verfügbaren Paketpreise werden auf der Produktseite und beim Checkout angezeigt.',
      'customizer.details.digital_how': 'So funktioniert es: Kaufe zum Beispiel ein Paket mit 3 Bildern. Das erste Bild wird sofort per E-Mail versendet; die übrigen 2 werden deinem Konto als Guthaben gutgeschrieben. Erstelle später ein neues Porträt und klicke auf „Für 1 Guthaben herunterladen“. Das Guthaben verfällt nicht.',
      'customizer.shipping.production': '⚡ Produktion: normalerweise 2–5 Werktage nach Freigabe des Bildes',
      'customizer.shipping.packaging': '📦 Sichere Verpackung: stabiler Karton und Luftpolsterfolie für einen sicheren Transport',
      'customizer.shipping.options': '🚚 Versand: verfügbare Versandoptionen werden beim Checkout angezeigt',
      'customizer.shipping.tracking': '📍 Sendungsverfolgung: Die Trackingnummer wird per E-Mail versendet',
      'customizer.shipping.cost': '💶 Versandkosten: werden beim Checkout berechnet',
      'customizer.shipping.delivery_time': '⏰ Lieferzeit: wird beim Checkout abhängig von der gewählten Option angezeigt',
      'customizer.sizes.prints': '🖼️ Poster / Leinwanddruck',
      'customizer.sizes.available': '📏 Verfügbare Größen',
      'customizer.sizes.description_imperial': 'Die verfügbaren Größen werden oben im Konfigurator angezeigt und hängen vom Druckformat ab. Die Maße sind in Zoll angegeben.',
      'customizer.sizes.description_metric': 'Die verfügbaren Größen werden oben im Konfigurator angezeigt und hängen vom Druckformat ab. Die Maße sind in Zentimetern angegeben.',
      'footer.policy_navigation': 'Rechtliche Informationen:',
      'footer.policy.privacy': 'Datenschutzerklärung',
      'footer.policy.refund': 'Rückerstattungsrichtlinie',
      'footer.policy.contact': 'Kontaktinformationen',
      'footer.policy.terms': 'Allgemeine Geschäftsbedingungen',
      'footer.policy.shipping': 'Versandrichtlinie',
      'theme.header.my_account': 'Mein Konto',
      'theme.header.my_images': 'Meine Bilder',
      'theme.header.log_out': 'Abmelden',
      'theme.header.log_in': 'Anmelden',
      'theme.header.register': 'Registrieren',
      'theme.header.search': 'Suchen',
      'theme.header.cart': 'Warenkorb',
      'theme.breadcrumb.label': 'Brotkrümelnavigation',
      'theme.breadcrumb.home': 'Startseite',
      'theme.breadcrumb.products': 'Produkte',
      'theme.hero.eyebrow': 'Personalisiertes Kunstwerk aus deinem Foto',
      'theme.hero.title': 'Verwandle ein Lieblingsfoto in ein Geschenk, das unvergessen bleibt',
      'theme.hero.description': 'Lade ein Foto hoch, erstelle deine Vorschau und bestelle erst, wenn du mit dem Ergebnis zufrieden bist.',
      'theme.hero.create': 'Kunstwerk erstellen',
      'theme.hero.how': 'So funktioniert es',
      'theme.hero.benefits': 'Vorteile des Shops',
      'theme.hero.preview': 'Vorschau vor dem Checkout',
      'theme.hero.made': 'Individuell angefertigt',
      'theme.hero.delivery': 'Sendungsverfolgung verfügbar',
      'theme.recommendations.title': 'Das könnte dir auch gefallen',
      'theme.recommendations.view_all': 'Alle Produkte anzeigen',
      'theme.reviews.title': 'Kundenbewertungen',
      'theme.reviews.view_all': 'Alle Bewertungen anzeigen',
      'theme.reviews.rating': '4,9/5 (143 Bewertungen)',
      'theme.reviews.1.date': '18. Juni 2026',
      'theme.reviews.1.text': '„Ich habe ein normales Handyfoto meines Vaters hochgeladen, und die Karikaturvorschau sah ihm tatsächlich ähnlich. Die Leinwand kam scharf und nicht verschwommen an, und die Farben entsprachen fast genau meiner Freigabe.“',
      'theme.reviews.1.style': 'Verifizierter Kauf · Leinwanddruck',
      'theme.reviews.2.date': '11. Juni 2026',
      'theme.reviews.2.text': '„Ich habe es als Geburtstagsgeschenk für meine Frau gekauft. Am besten fand ich, dass ich die Vorschau schon vor dem Checkout sehen konnte. Es wirkte persönlich und nicht wie ein beliebiges Poster mit aufgeklebtem Foto.“',
      'theme.reviews.2.style': 'Verifizierter Kauf · Gerahmtes Poster',
      'theme.reviews.3.date': '29. Mai 2026',
      'theme.reviews.3.text': '„Ich war unsicher, weil mein Foto nicht perfekt war, aber die Vorschau machte die Entscheidung leicht. Der gerahmte Druck sieht sauber aus, und die Gesichtszüge kommen besser zur Geltung als erwartet.“',
      'theme.reviews.3.style': 'Verifizierter Kauf · Poster im Holzrahmen',
      'theme.reviews.4.date': '21. Mai 2026',
      'theme.reviews.4.text': '„Ich habe eines für meinen Bruder bestellt, und er musste schon lachen, bevor er es ganz ausgepackt hatte. Die Karikatur war lustig, ohne gemein zu wirken – genau das wollte ich.“',
      'theme.reviews.4.style': 'Verifizierter Kauf · Karikaturporträt',
      'theme.reviews.5.date': '9. Mai 2026',
      'theme.reviews.5.text': '„Der Druck war ein Geschenk für meine Eltern. Mir gefiel, dass ich Größe und Rahmen erst nach der KI-Vorschau auswählen konnte. Das Ergebnis wirkt hochwertiger als erwartet.“',
      'theme.reviews.5.style': 'Verifizierter Kauf · Gerahmte Leinwand',
      'theme.reviews.6.date': '27. Apr. 2026',
      'theme.reviews.6.text': '„Ich habe ein Bild unseres Hundes verwendet, und das Ergebnis hat seinen Ausdruck wirklich bewahrt. Das Poster war gut verpackt und gestochen scharf – nicht wie eine billige Vergrößerung.“',
      'theme.reviews.6.style': 'Verifizierter Kauf · Tierporträt-Poster',
      'theme.reviews.7.date': '14. Apr. 2026',
      'theme.reviews.7.text': '„Die Vorschau entsprach dem fertigen Druck sehr genau. Mir gefiel, dass das Kunstwerk aus meinem eigenen Foto erstellt wurde und dadurch wirklich einzigartig wirkte.“',
      'theme.reviews.7.style': 'Verifizierter Kauf · Individuelles KI-Porträt',
      'theme.cart.title': 'Warenkorb',
      'theme.cart.view_all': 'Alle anzeigen',
      'theme.cart.property.size': 'Größe:',
      'theme.cart.property.print_type': 'Druckart:',
      'theme.cart.property.frame': 'Rahmen:',
      'theme.cart.checkout': 'Zur Kasse',
      'theme.cart.payment_alt': 'Akzeptierte Zahlungsmethoden: Mastercard, Maestro, Visa, Visa Electron und Apple Pay',
      'theme.cart.payment_title': 'Karten, Apple Pay & Google Pay',
      'theme.cart.payment_text': 'Sichere Zahlung per Karte oder Wallet',
      'theme.cart.made_title': 'Individuell angefertigt',
      'theme.cart.made_text': 'Produktion normalerweise innerhalb von 2–5 Werktagen',
      'theme.cart.delivery_title': 'Sendungsverfolgung',
      'theme.cart.delivery_text': 'Versandoptionen werden beim Checkout angezeigt',
      'theme.cart.printing_title': 'Qualitätsgeprüfter Druck',
      'theme.cart.printing_text': 'Jeder Druck wird vor dem Versand sorgfältig geprüft',
      'customizer.howto.upload_title': 'Foto hochladen',
      'customizer.howto.upload_description': 'JPG, PNG oder GIF bis 10 MB. Eine hohe Auflösung liefert das beste Ergebnis.',
      'customizer.howto.upload_note': 'Keine Sorge wegen der Qualität – wir prüfen jedes Foto vor dem Druck und optimieren es bei Bedarf.',
      'customizer.howto.style_title': 'Kunststil auswählen',
      'customizer.howto.style_description': 'Die verfügbaren Stile findest du oben im Konfigurator.',
      'customizer.howto.size_title': 'Druckgröße auswählen',
      'customizer.howto.size_description': 'Wähle die passende Größe für deinen Raum.',
      'customizer.howto.ai_title': 'KI verwandelt dein Foto',
      'customizer.howto.ai_description': 'Die KI erstellt deine Vorschau in 30–60 Sekunden.',
      'customizer.howto.ship_title': 'Wir drucken und versenden',
      'customizer.howto.ship_description': 'Jedes Bild wird vor dem Druck geprüft, hochwertig gedruckt und sicher verpackt.',
      "customizer.upload.photo": "Foto {number}",
      "customizer.upload.file_type": "Diese Datei kann nicht geöffnet werden.",
      "customizer.upload.file_size": "Diese Fotodatei ist zu groß.",
      "customizer.upload.file_empty": "Dieses Foto kann nicht geöffnet werden.",
      "customizer.upload.file_resolution": "Dieses Foto ist zu klein. Bitte wähle ein größeres Foto.",
      "customizer.upload.low_resolution_warning": "Du kannst dieses Foto verwenden, aber Details können ungenauer sein. Ein größeres, schärferes Foto liefert bessere Ergebnisse.",
      "customizer.upload.file_decode": "Dieses Foto kann nicht geöffnet werden.",
      "customizer.upload.file_read": "Dieses Foto kann nicht geöffnet werden.",
      "customizer.upload.file_upload": "Dieses Foto konnte nicht gesendet werden. Prüfe deine Verbindung und versuche es erneut.",
      "customizer.upload.file_timeout": "Dieses Foto konnte nicht geladen werden. Bitte versuche es erneut.",
      "customizer.upload.browser_unsupported": "Dein Browser kann Fotodateien nicht lesen. Aktualisiere ihn oder nutze einen anderen Browser.",
      "customizer.upload.crop_export": "Dieses Foto konnte nicht zugeschnitten werden.",
      "customizer.upload.crop_unavailable": "Der Fotoeditor konnte nicht geladen werden. Aktualisiere die Seite und versuche es erneut.",
      "customizer.upload.choose_another": "Wähle ein anderes Foto.",
      "customizer.upload.previous_kept": "Dein bisheriges Foto ist weiterhin ausgewählt.",
      "customizer.upload.still_loading": "Dein Foto wird noch geprüft. Warte auf die Vorschau, bevor du fortfährst.",
      "customizer.upload.checking": "Foto wird geprüft…",
      "customizer.upload.compression": "Das Foto konnte nicht komprimiert werden.",
      "customizer.upload.missing_photo": "Füge ein Foto hinzu, bevor du fortfährst.",
      "customizer.upload.crop_required": "Bestätige den Fotoausschnitt, bevor du fortfährst.",
      'customizer.error.image_file': 'Wähle eine Bilddatei aus (JPG oder PNG)',
      'customizer.error.file_too_large': 'Die Datei ist zu groß (max. 10 MB)',
      'customizer.error.upload_photo_style': 'Lade ein Foto hoch und wähle einen Stil aus',
      'customizer.error.size_required': 'Du hast keine Größe ausgewählt',
      'customizer.error.product_type_unavailable': 'Diese Produktart ist nicht verfügbar. Wähle Leinwand, Poster oder Digitales Produkt.',
      'customizer.error.generate_preview_first': 'Lade zuerst ein Foto hoch und erstelle deine Vorschau',
      'customizer.error.choose_style': 'Wähle einen Stil aus',
      'customizer.error.price_calculation': 'Der Preis konnte nicht berechnet werden. Bitte versuche es erneut.',
      'customizer.error.ai_failed': 'Die Bildgenerierung ist fehlgeschlagen: {reason}',
      'customizer.error.unknown': 'Unbekannter Fehler',
      'customizer.error.network_retry': 'Netzwerkfehler – neuer Versuch {attempt}/3...',
      'customizer.error.server_connection': 'Verbindung zum Server fehlgeschlagen',
      'customizer.error.transform_timeout': 'Die Anfrage hat zu lange gedauert (5 Minuten). Bitte versuche es erneut.',
      'customizer.error.network_check': 'Netzwerkfehler. Prüfe deine Internetverbindung und versuche es erneut.',
      'customizer.error.network_short': 'Netzwerkfehler. Bitte versuche es gleich noch einmal.',
      'customizer.error.processing': 'Die Verarbeitung ist fehlgeschlagen. Bitte versuche es erneut.',
      'customizer.error.add_to_cart': 'Das Produkt konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.',
      'customizer.error.product_creation': 'Das Produkt konnte nicht erstellt werden: {reason}',
      'customizer.field.name.label': 'Name oder Widmung – dieser Text erscheint unten im Bild',
      'customizer.field.name.placeholder': 'z. B. Anna',
      'customizer.field.names.label': 'Namen oder Widmung – dieser Text erscheint im Bild',
      'customizer.field.names.placeholder': 'z. B. Anna & Mark',
      'customizer.field.years.label': 'Jahrestag / Anzahl der Jahre – diese Zahl erscheint im Bild',
      'customizer.field.years.placeholder': 'z. B. 10, 25, 50',
      'customizer.field.personalization.label': 'Person, Beruf, Hobby oder Thema beschreiben – diese Angaben bestimmen den Bildstil',
      'customizer.field.personalization.placeholder': 'z. B. Pflegekraft, Reisen | Lehrer, Sport',
      'customizer.field.signature.label': 'Vor- und Nachname (Signatur am unteren Rand)',
      'customizer.field.signature.placeholder': 'z. B. MARKUS SCHMIDT',
      'customizer.field.watercolor_text.label': 'Signatur oder Widmung hinzufügen – sie erscheint unten im Bild',
      'customizer.field.watercolor_text.placeholder': 'z. B. Power Couple',
      'customizer.field.story_scene.label': 'Pose oder Szene (optional)',
      'customizer.field.story_dedication.label': 'Kurze Widmung hinzufügen (optional)',
      'customizer.field.story_dedication.placeholder': 'z. B. Für immer zusammen',
      'customizer.story.saloon.1': 'Stehend',
      'customizer.story.saloon.2': 'An einem Tisch sitzend',
      'customizer.story.saloon.3': 'Auf dem Pferd',
      'customizer.story.royal.1': 'Eine Person sitzt, die andere steht',
      'customizer.story.royal.2': 'Beide stehend',
      'customizer.story.royal.3': 'Beide sitzend',
      'customizer.story.swing.1': 'Auf der Schaukel',
      'customizer.story.swing.2': 'Auf einer Bank',
      'customizer.story.swing.3': 'Zusammen stehend',
      'customizer.story.highland.1': 'Auf einem Hochlandkamm',
      'customizer.story.romantic.1': "Wie auf dem Produktbild",
      'customizer.story.romantic.2': "Im Garten stehend",
      'customizer.story.romantic.3': "An einem Steinbalkon",
      'customizer.story.legacy.1': "Wie auf dem Produktbild",
      'customizer.story.legacy.2': "Zusammen stehend",
      'customizer.story.legacy.3': "Zusammen sitzend",
      'customizer.story.fairytale.1': "Wie auf dem Produktbild",
      'customizer.story.fairytale.2': "Im Garten stehend",
      'customizer.story.fairytale.3': "Mit einem kleinen Blumenstrauß",
      'customizer.story.dynasty.1': "In einem herrschaftlichen Anwesen",
      'customizer.story.dynasty.2': "In einer großen Bibliothek",
      'customizer.story.dynasty.3': "Auf einer Gartenterrasse",
      'customizer.story.floral.1': "In einem blühenden Wintergarten",
      'customizer.story.floral.2': "An einer Steinbalustrade",
      'customizer.story.floral.3': "Auf einem Weg im Rosengarten",
      'customizer.story.ballroom.1': "Beim Tanz im Ballsaal",
      'customizer.story.ballroom.2': "Unter Kronleuchtern stehend",
      'customizer.story.ballroom.3': "An hohen Ballsaalfenstern",
      'customizer.story.regal.1': "In einer historischen Halle",
      'customizer.story.regal.2': "In einer privaten Bibliothek",
      'customizer.story.regal.3': "An einem hohen Steinfenster",
      'customizer.story.tree.1': "Unter dem alten Baum",
      'customizer.story.tree.2': "Auf einer Wildblumenwiese",
      'customizer.story.tree.3': "Mit Blick auf sanfte Hügel",
      'customizer.story.deco.1': 'In einer Art-déco-Lobby',
      'customizer.story.deco.2': 'Neben einem Oldtimer',
      'customizer.story.deco.3': 'An einer großen Treppe',
      'customizer.story.sapphire.1': 'In einer Schlossgalerie',
      'customizer.story.sapphire.2': 'An hohen Fenstern',
      'customizer.story.sapphire.3': 'Auf einer Gartenterrasse',
      'customizer.story.aviator.1': 'Neben einem geparkten Flugzeug',
      'customizer.story.aviator.2': 'In einem Flugzeughangar',
      'customizer.story.aviator.3': 'Auf einer Graspiste',
      'customizer.story.power.1': 'In einem Penthouse',
      'customizer.story.power.2': 'An Fenstern mit Stadtblick',
      'customizer.story.power.3': 'Auf einer Dachterrasse',
      'customizer.story.highland.2': 'Neben einer Steinburg',
      'customizer.story.highland.3': 'An einem nebligen See',
      'customizer.story.viking.1': 'An einem nordischen Fjord',
      'customizer.story.mafia_portrait.1': 'In einem Ledersessel sitzend',
      'customizer.story.mafia_portrait.2': 'In einer Bibliothek stehend',
      'customizer.story.mafia_portrait.3': 'Neben einem Oldtimer',
      'customizer.story.royal_portrait.1': 'In einer Schlossgalerie',
      'customizer.story.royal_portrait.2': 'Auf einem Thron sitzend',
      'customizer.story.royal_portrait.3': 'An hohen Fenstern',
      'customizer.story.knight_portrait.1': 'An einem Burgtorbogen',
      'customizer.story.knight_portrait.2': 'In einem großen Saal',
      'customizer.story.knight_portrait.3': 'In einem Burghof',
      'customizer.story.viking.2': 'Neben einem Langschiff',
      'customizer.story.viking.3': 'In einer großen Holzhalle',
      'customizer.story.pirate.1': 'Zusammen auf dem Deck stehend',
      'customizer.story.pirate.2': 'Am Steuerrad',
      'customizer.story.pirate.3': 'Auf einer Truhe sitzend',
      'customizer.story.cowboy.1': 'Auf dem Pferd',
      'customizer.story.cowboy.2': 'Stehend in der Westernstadt',
      'customizer.story.cowboy.3': 'Stehend vor einem Canyon',
      'customizer.field.headline_1.label': 'Überschrift 1 (optional)',
      'customizer.field.headline_1.placeholder': 'z. B. ARCHITEKT MEINES EIGENEN ERFOLGS',
      'customizer.field.headline_2.label': 'Überschrift 2 (optional)',
      'customizer.field.headline_2.placeholder': 'z. B. ERFOLG IST STRATEGIE, KEIN GLÜCK',
      'customizer.field.scene_type.label': 'Art der Szene',
      'customizer.field.scene_type.placeholder': 'z. B. Jahrestag',
      'customizer.field.character_description.label': 'Charakter oder Stimmung beschreiben',
      'customizer.field.character_description.placeholder': 'z. B. elegant, romantisch, festlich',
      'customizer.field.couple_pose.label': 'Pose des Paares',
      'customizer.field.groom_outfit.label': 'Kleidung des Bräutigams',
      'customizer.field.groom_outfit.placeholder': 'z. B. grüner Anzug, schwarzer Smoking, dunkelblauer Blazer',
      'customizer.field.bride_outfit.label': 'Kleidung der Braut',
      'customizer.field.bride_outfit.placeholder': 'z. B. weißes Kleid mit Schleier, trägerloses Brautkleid',
      'customizer.field.wedding_background.label': 'Hintergrund / Ort',
      'customizer.field.wedding_background.placeholder': 'z. B. Kirche, Trauung im Freien, Hochzeitslocation, Strand bei Sonnenuntergang',
      'customizer.field.scene_description.label': 'Szene oder Stimmung beschreiben',
      'customizer.field.scene_description.placeholder': 'z. B. Familienessen, Geschäftstreffen, Picknick im Park',
      'customizer.field.dedication.label': 'Text oder Widmung hinzufügen',
      'customizer.field.dedication.placeholder': 'z. B. Liebe Mama, frohe Feiertage!',
      'customizer.field.banner_text.label': 'Text für das Banner im Bild hinzufügen',
      'customizer.field.banner_text.placeholder': 'z. B. Anna und Mark – für immer zusammen',
      'customizer.field.gta_text.label': 'Text hinzufügen – er erscheint unten im Bild',
      'customizer.field.gta_text.placeholder': 'z. B. Power Couple',
      'customizer.field.gta_look.label': 'Outfit / Look',
      'customizer.field.gta_scene.label': 'Szene / Stadt',
      'customizer.field.gta_vehicle.label': 'Fahrzeug',
      'customizer.field.gta_mood.label': 'Stimmung',
      'customizer.field.gta_props.label': 'Was soll zusätzlich im Bild erscheinen? (optional)',
      'customizer.field.gta_props.placeholder': 'z. B. Husky, Gitarre, mein schwarzer BMW E46',
      'customizer.gta.look.1': 'Vice City – Hawaiihemd, Bikini/Crop-Top',
      'customizer.gta.look.2': 'Gangster – Goldketten, Tanktop, Bandana',
      'customizer.gta.look.3': 'Street – Lederjacke, Hoodie, Sneaker',
      'customizer.gta.look.4': 'Boss – Anzug, Cocktailkleid',
      'customizer.gta.look.5': 'Wie auf dem Foto',
      'customizer.gta.scene.1': 'Vice City – Strand, Palmen, Neon',
      'customizer.gta.scene.2': 'Los Santos – Innenstadt, Wolkenkratzer',
      'customizer.gta.scene.3': 'Stadt bei Nacht – Regen, Neon',
      'customizer.gta.scene.4': 'Hügel – Villa mit Pool, Stadtblick',
      'customizer.gta.scene.5': 'Garage / Werkstatt',
      'customizer.gta.vehicle.1': 'Supersportwagen',
      'customizer.gta.vehicle.2': 'Motorrad',
      'customizer.gta.vehicle.3': 'Retro-Cabriolet',
      'customizer.gta.vehicle.4': 'Hubschrauber im Hintergrund',
      'customizer.gta.vehicle.5': 'Kein Fahrzeug',
      'customizer.gta.mood.1': 'Action – Geld, Explosionen, Polizei im Hintergrund',
      'customizer.gta.mood.2': 'Entspannt – Urlaub, Strand, Drinks',
      'customizer.gta.mood.3': 'Elegant – Anzüge, Casino, nächtliche Stadt'
    })
  });

  function normalizeLocale(locale) {
    return String(locale || DEFAULT_LOCALE).trim().toLowerCase().split(/[-_]/)[0] || DEFAULT_LOCALE;
  }

  function interpolate(template, params) {
    return String(template).replace(/\{([a-zA-Z0-9_]+)\}/g, function replaceToken(match, name) {
      return Object.prototype.hasOwnProperty.call(params || {}, name) ? String(params[name]) : match;
    });
  }

  function reportMissingKey(locale, key) {
    var diagnosticKey = locale + ':' + key;
    if (missingKeys.has(diagnosticKey)) return;
    missingKeys.add(diagnosticKey);
    console.warn('[CUSTOMIFY-I18N] Missing translation', { locale: locale, key: key });

    try {
      if (root.Sentry && typeof root.Sentry.captureMessage === 'function') {
        root.Sentry.captureMessage('Customify translation missing', {
          level: 'warning',
          tags: { locale: locale, translation_key: key }
        });
      }
    } catch (_) {}
  }

  function translate(key, params) {
    var locale = normalizeLocale(context.locale);
    var localeMessages = messages[locale] || {};
    var template = localeMessages[key];

    if (locale === 'en' && context.country === 'GB') {
      if (key === 'theme.cart.printing_title') template = 'UK-based printing';
      if (key === 'theme.cart.printing_text') template = 'Printed for customers across the United Kingdom';
    }

    if (typeof template !== 'string') {
      template = messages[DEFAULT_LOCALE][key];
      if (locale !== DEFAULT_LOCALE) reportMissingKey(locale, key);
    }

    if (typeof template !== 'string') {
      reportMissingKey(locale, key);
      return '';
    }

    return interpolate(template, params || {});
  }

  function translateDocument() {
    if (!root.document || typeof root.document.querySelectorAll !== 'function') return;
    root.document.querySelectorAll('[data-customify-i18n]').forEach(function(element) {
      var key = element.getAttribute('data-customify-i18n');
      var text = translate(key);
      if (text && element.textContent !== text) element.textContent = text;
    });
    root.document.querySelectorAll('[data-customify-i18n-placeholder]').forEach(function(element) {
      var key = element.getAttribute('data-customify-i18n-placeholder');
      var text = translate(key);
      if (text && element.getAttribute('placeholder') !== text) element.setAttribute('placeholder', text);
    });
    root.document.querySelectorAll('[data-customify-i18n-aria-label]').forEach(function(element) {
      var key = element.getAttribute('data-customify-i18n-aria-label');
      var text = translate(key);
      if (text && element.getAttribute('aria-label') !== text) element.setAttribute('aria-label', text);
    });
    root.document.querySelectorAll('[data-customify-i18n-alt]').forEach(function(element) {
      var key = element.getAttribute('data-customify-i18n-alt');
      var text = translate(key);
      if (text && element.getAttribute('alt') !== text) element.setAttribute('alt', text);
    });
    root.document.querySelectorAll('img[alt="Accepted payment methods: Mastercard, Maestro, Visa, Visa Electron and Apple Pay"]').forEach(function(element) {
      var text = translate('theme.cart.payment_alt');
      if (text && element.getAttribute('alt') !== text) element.setAttribute('alt', text);
    });

    if (normalizeLocale(context.locale) === 'de' && typeof root.document.createTreeWalker === 'function' && root.NodeFilter) {
      var cartPropertyValueTranslations = {
        'Canvas print': 'Leinwanddruck',
        'Canvas print (canvas)': 'Leinwanddruck',
        'Canvas print with black frame': 'Leinwanddruck mit schwarzem Rahmen',
        'Canvas print with white frame': 'Leinwanddruck mit weißem Rahmen',
        'Canvas print with wood frame': 'Leinwanddruck mit Holzrahmen',
        'Canvas print (canvas) with black frame': 'Leinwanddruck mit schwarzem Rahmen',
        'Canvas print (canvas) with white frame': 'Leinwanddruck mit weißem Rahmen',
        'Canvas print (canvas) with wood frame': 'Leinwanddruck mit Holzrahmen',
        'Poster with black frame': 'Poster mit schwarzem Rahmen',
        'Poster with white frame': 'Poster mit weißem Rahmen',
        'Poster with wood frame': 'Poster mit Holzrahmen',
        'Digital download file': 'Digitales Produkt',
        'frame - none': 'Ohne Rahmen',
        'frame - black': 'Schwarz',
        'frame - white': 'Weiß',
        'frame - wood': 'Holz',
        none: 'Ohne Rahmen'
      };
      root.document.querySelectorAll('.cart-items__properties dd').forEach(function(element) {
        var rawValue = element.textContent || '';
        var trimmedValue = rawValue.trim();
        var translatedValue = cartPropertyValueTranslations[trimmedValue];
        if (translatedValue) element.textContent = rawValue.replace(trimmedValue, translatedValue);
      });

      var exactTextKeys = {
        Cart: 'theme.cart.title',
        Home: 'theme.breadcrumb.home',
        Products: 'theme.breadcrumb.products',
        'You may also like': 'theme.recommendations.title',
        'View all products': 'theme.recommendations.view_all',
        'View all': 'theme.cart.view_all',
        'Size:': 'theme.cart.property.size',
        'Print type:': 'theme.cart.property.print_type',
        'Frame:': 'theme.cart.property.frame',
        'Check out': 'theme.cart.checkout',
        Auschecken: 'theme.cart.checkout'
      };
      var walker = root.document.createTreeWalker(root.document.body, root.NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var rawText = node.nodeValue || '';
        var trimmedText = rawText.trim();
        var translationKey = exactTextKeys[trimmedText];
        if (!translationKey) continue;
        var translatedText = translate(translationKey);
        if (translatedText) node.nodeValue = rawText.replace(trimmedText, translatedText);
      }
    }
  }

  root.CustomifyI18n = Object.freeze(Object.assign({}, context, {
    defaultLocale: DEFAULT_LOCALE,
    locale: normalizeLocale(context.locale),
    messages: messages,
    t: translate,
    translateDocument: translateDocument
  }));

  if (root.document) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', translateDocument, { once: true });
    } else {
      translateDocument();
    }
    if (normalizeLocale(context.locale) === 'de' && typeof root.MutationObserver === 'function') {
      var translationScheduled = false;
      var observer = new root.MutationObserver(function() {
        if (translationScheduled) return;
        translationScheduled = true;
        root.setTimeout(function() {
          translationScheduled = false;
          translateDocument();
        }, 0);
      });
      var observeWhenReady = function() {
        if (root.document.body) observer.observe(root.document.body, { childList: true, subtree: true });
      };
      if (root.document.readyState === 'loading') {
        root.document.addEventListener('DOMContentLoaded', observeWhenReady, { once: true });
      } else {
        observeWhenReady();
      }
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
